import Markdown from 'react-markdown';

import './CustomMarkdown.scss';

export const CustomReactMarkdown = ({ children }: { children: string }) => {
  return (
    <Markdown
      components={{
        h1: ({ node, ...props }) => (
          <h3 {...props} className={'custom-markdown__title3'} />
        ),
        h2: ({ node, ...props }) => (
          <h3 {...props} className={'custom-markdown__title3'} />
        ),
        h3: ({ node, ...props }) => (
          <h3 {...props} className={'custom-markdown__title3'} />
        ),
        ul: ({ node, ...props }) => (
          <ul {...props} className={'custom-markdown__unordered-list'} />
        ),
        ol: ({ node, ...props }) => (
          <ol {...props} className={'custom-markdown__ordered-list'} />
        ),
        strong: ({ node, ...props }) => (
          <strong {...props} className={'custom-markdown__highlight'} />
        ),
        hr: ({ node, ...props }) => (
          <hr {...props} className={'custom-markdown__divider'} />
        ),
        p: ({ node, ...props }) => (
          <p {...props} className={'custom-markdown__paragraph'} />
        ),
      }}
    >
      {children}
    </Markdown>
  );
};
